var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action-button",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e(),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }